import React from "react";
import SuspenseWrapper from "@/router/component/SuspenseWrapper";
import { AdminAttendanceInfo, AdminAttendanceMuster, MonthEndProcess, OnsiteAttendanceProcess, ShiftRoster, ShiftRosterExcelImport, WeekendPolicy, ShiftMaster, DayType, AdminAttendanceReport, AttendanceTracker } from "@/pages/attendanceManagement";



const Index = [
  {
    path: "/adminAttendance/adminAttendanceInfo",
    element: (
      <SuspenseWrapper>
        <AdminAttendanceInfo />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/onsiteAttendanceProcess",
    element: (
      <SuspenseWrapper>
        <OnsiteAttendanceProcess />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/weekendPolicy",
    element: (
      <SuspenseWrapper>
        <WeekendPolicy />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/attendanceMuster",
    element: (
      <SuspenseWrapper>
        <AdminAttendanceMuster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/monthEndProcess",
    element: (
      <SuspenseWrapper>
        <MonthEndProcess />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/shiftMaster",
    element: (
      <SuspenseWrapper>
        <ShiftMaster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/shiftRoster",
    element: (
      <SuspenseWrapper>
        <ShiftRoster />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/shiftRosterImport",
    element: (
      <SuspenseWrapper>
        <ShiftRosterExcelImport />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/dayTypeHistory",
    element: (
      <SuspenseWrapper>
        <DayType />
      </SuspenseWrapper>
    ),
  },
  {
    path: "/adminAttendance/attendanceReport",
    element: (
      <SuspenseWrapper>
        <AdminAttendanceReport />
      </SuspenseWrapper>
    ),
  },
   {
    path: "/adminAttendance/tracker",
    element: (
      <SuspenseWrapper>
        <AttendanceTracker />
      </SuspenseWrapper>
    ),
  },
  
];

export default Index;
